import { Heading, Button, Img } from "./..";
import React from "react";

export default function VisionStatement({
  featureTitle = "Our Vision",
  descriptionText = "To become a one-stop digital twin platform for the manufacturing industry. We seek to provide a comprehensive platform that enables industries to operate efficiently, paving the way for a sustainable future and advancing the global effort towards decarbonization.",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col items-center md:w-full gap-6 p-10 sm:p-5 border-blue-a200_a5 border border-solid bg-gradient4 rounded-[10px]`}
    >
      <div className="mx-1.5 flex items-center gap-6 self-stretch">
        <Button color="blue_100_01" size="5xl" shape="circle" className="w-[60px] rounded-[30px] px-2">
          <Img src="images/img_ion_telescope_outline.svg" />
        </Button>
        <Heading size="heading12xl" as="h2" className="text-[35px] font-bold text-color_style-01_neutrals-grey700">
          {featureTitle}
        </Heading>
      </div>
      <Heading
        size="text7xl"
        as="p"
        className="mb-5 w-full text-[20px] font-normal leading-[30px] text-color_style-01_neutrals-grey600 sm:text-[16px]"
      >
        {descriptionText}
      </Heading>
    </div>
  );
}
